import { render, staticRenderFns } from "./ModalAssingOT.vue?vue&type=template&id=3874932c&"
import script from "./ModalAssingOT.vue?vue&type=script&lang=js&"
export * from "./ModalAssingOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports